<div id="content" class="allcp-form" ng-controller="CustomerAccountController">
<div ng-include="'modules/customer/partials/top_menu.html'"></div>
    <div class="row">
        <div class="panel-body pr10 pl10" style="min-height: 10; max-height: 10;">
            <div class="col-md-9">
                <form class="form-horizontal" name="change_password_form" novalidate ng-submit="change_password_form.$valid && updatePassword()">
                    
                    <div class="form-group">
                        <label for="old_password" class="col-md-3 control-label">Eski Şifre:</label>
                        <div class="col-md-9">
                            <label for="old_password" class="field prepend-icon">
                                <input type="password" name="old_password" id="old_password" ng-minlength="6" placeholder="******" class="gui-input" ng-model="password.old_password" required>
                                <label for="old_password" class="field-icon">
                                    <i class="fa fa-lock"></i>
                                </label>
                            </label>
                            <span style="font-family: cursive;color: red;font-size: 12px" ng-show="change_password_form.old_password.$dirty&&change_password_form.old_password.$error.required" >Required *</span>
                            <span style="font-family: cursive;color: red;font-size: 11px" ng-show="change_password_form.old_password.$dirty&&change_password_form.old_password.$error.minlength" >Value should be more than 6</span>										
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="new_password" class="col-md-3 control-label">Yeni Şifre:</label>
                        <div class="col-md-9">
                            <label for="new_password" class="field prepend-icon">
                                <input type="password" name="new_password" id="new_password" ng-minlength="6"  placeholder="******" class="gui-input" ng-model="password.new_password" required>
                                <label for="new_password" class="field-icon">
                                    <i class="fa fa-lock"></i>
                                </label>
                            </label>
                            <span style="font-family: cursive;color: red;font-size: 12px" ng-show="change_password_form.new_password.$dirty&&change_password_form.new_password.$error.required" >Required *</span>
                            <span style="font-family: cursive;color: red;font-size: 11px" ng-show="change_password_form.new_password.$dirty&&change_password_form.new_password.$error.minlength" >Value should be more than 6</span>										
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="cofirm_new_password"
                            class="col-md-3 control-label">Yeni Şifre Tekrar:</label>

                        <div class="col-md-9">
                            <label for="cofirm_new_password" class="field prepend-icon">
                                <input type="password" name="cofirm_new_password" id="cofirm_new_password" placeholder="******" class="gui-input" ng-model="password.new_password_repeat" required compare-to="password.new_password">
                                <label for="cofirm_new_password" class="field-icon">
                                    <i class="fa fa-lock"></i>
                                </label>
                            </label>
                            <span style="font-family: cursive;color: red;font-size: 12px" ng-show="change_password_form.cofirm_new_password.$dirty&&change_password_form.cofirm_new_password.$error.required" >Required *</span>
                            <span style="font-family: cursive;color: red;font-size: 12px" ng-show="change_password_form.cofirm_new_password.$error.compareTo" >Value should be same !</span>
                        </div>
                    </div>
                    
                        
                    <div class="form-group">
                        <div class="col-md-12">
                            <div class="pull-right">
                                <button type="submit" class="btn btn-primary">Şifre Değiştir</button>
                            </div>
                        </div>
                    </div>
                    
                </form>
            </div>
        </div>
    </div>
</div>